<template>
  <!-- Events-->
  <div v-if="capacity">
    <v-menu offset-y origin="center center" transition="scale-transition">
      <template v-slot:activator="{ on, attrs }">
        <v-sheet
          rounded
          :color="getCapacityColor()"
          class="calendar-event d-flex justify-center text-caption font-weight-medium"
          v-ripple
          v-bind="attrs"
          v-on="on"
        >
          <span>{{ session.name }}</span>
        </v-sheet>
      </template>
      <v-card min-width="170px" class="">
        <v-card-title class="text-overline">Details</v-card-title>
        <v-card-text class="text-caption pb-0">
          <div>
            Wann: {{ session.day }}, {{ session.start }} -
            {{ session.end }}
          </div>
          <div>Wie: {{ formatFormat(capacity.format) }}</div>
          <div>
            Wo:
            <span v-if="session.link">{{ session.link }}</span>
            <span v-else-if="capacity.room">{{ capacity.room }}</span>
            <span v-else>tba</span>
          </div>
          <div>Wer: {{ tutor }}</div>
          <div>Wie voll: {{ formatCap(capacity.capacity) }} belegt</div>
        </v-card-text>
        <v-btn
          small
          text
          color="tertiary"
          class="mt-2 px-0 ml-3"
          @click="toSessionView"
        >
          Mehr
        </v-btn>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<style scoped>
.v-card__title {
  padding-bottom: 0;
  padding-top: 8px;
}

.calendar-event {
  color: white;
  padding: 5px;
  margin: 3px 10px;
}

button {
  background-color: transparent;
}
</style>

<script>
export default {
  name: "Event",
  props: {
    session: Object,
    tutor: String,
    capacity: Object,
  },
  data: function () {
    return {
      notCrowded: "#64A0C8",
      normal: "#3D82AF",
      crowded: "#2D5E7F",
      busy: "#22475F",
      modified: "#E99A27",
      cancelled: "#E47B73",
      homework: "#8a8989",
    };
  },
  methods: {
    toSessionView() {
      const routeData = this.$router.resolve({
        name: "tutorials.id",
        params: {
          sessionId: this.session.id.toString(),
          capacity: this.capacity.capacity,
          room: this.capacity.room || "",
          tutorialId: this.capacity.id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    getCapacityColor() {
      if (this.capacity == null) return this.normal;
      const cap = this.capacity.capacity;
      const stat = this.session.status;
      if (stat === "PLANED") {
        if (this.capacity.programming_tutorial) {
          return this.homework;
        }
        if (cap === "NOT_CROWDED") {
          return this.notCrowded;
        } else if (cap === "NORMAL") {
          return this.normal;
        } else if (cap === "CROWDED") {
          return this.crowded;
        } else if (cap === "BUSY") {
          return this.busy;
        } else {
          return this.normal;
        }
      } else if (stat === "MODIFIED") {
        return this.modified;
      } else if (stat === "CANCELED") {
        return this.cancelled;
      } else {
        return this.normal;
      }
    },
    formatCap(c) {
      if (c === "NOT_CROWDED") {
        return "kaum";
      } else if (c === "NORMAL") {
        return "normal";
      } else if (c === "CROWDED") {
        return "stärker";
      } else if (c === "BUSY") {
        return "voll";
      } else {
        return "";
      }
    },
  },
};
</script>
